import { SET_RESTAURANT_REGIMES } from "../restaurant/constants";

const initState = [];

export default function restaurantRegimerReducer(state = initState, action) {
  switch (action.type) {
    case SET_RESTAURANT_REGIMES: {

      if (typeof action.payload === 'object') {
        return action.payload;
      }
      return state;
    }

    default:
      return state;
  }
}
